<form #newModule (ngSubmit)="submit($event)" class="mt-4 mb-0">
  <div class="fieldset fieldset--lg">
    <p class="text-center text-sm">{{file?.name || 'No File Selected'}}</p>
    <button (click)="mediafile.click()" type="button" id="mediafileLabel" class="btn m-auto">Select
      File</button>
    <input #mediafile (change)="file = mediafile.files[0]; mediatitle = file?.name" type="file" name="mediafile"
      aria-labelledby="mediafileLabel" id="mediafile" class="sr-only" autofocus required>
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Selecting a file"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">The file goes into this course's media library and its size counts towards your school's storage allowance. Audio and video are converted after upload and are not usable until that finishes; you are emailed when it does.</p>
    </div>
  </div>
  <div class="fieldset fieldset--lg">
    <label class="legend" for="title">Title <span class="requiredfield">*</span></label>
    <input type="text" name="title" id="title" class="text-field" [(ngModel)]="mediatitle" required="required">
    <button type="button" data-toggle="dropdown" aria-expanded="false" title="Title"
      class="position-absolute right-0 top-0 bottom-0 m-auto d-flex align-items-center pr-3 bg-transparent border-0 text-body"><i
        class="fa fa-info-circle"></i></button>
    <div class="info-popup dropdown-menu p-2">
      <p class="form-info-p">The name this file appears under in the media library. It starts as the file name.</p>
    </div>
  </div>
  <div class="d-flex justify-content-center flex-wrap gap-1.5">
    <button *ngIf="uploading; else notUploading" type="button" class="btn btn--loading m-0">Uploading... {{uploadpercentage}}%</button>
    <ng-template #notUploading>
      <button [disabled]="!selectedFileValid() || submitted" type="submit" class="btn m-0">Upload</button>
    </ng-template>
    <button routerLink="/user/modulemedialibrary"
      [queryParams]="{moduleid: this.moduleid}" type="button" class="btn btn--warning m-0">Cancel</button>
  </div>
</form>
